import { SupabaseClient } from "@supabase/supabase-js";
import { createSupabaseClient } from "./utils/clientFactory";
import { validateConnection } from "./utils/connectionValidator.ts";

export class OrganizationClient {
  private client: SupabaseClient;
  private url: string;

  constructor(supabaseUrl: string, supabaseAnonKey: string) {
    this.url = supabaseUrl;
    this.client = createSupabaseClient({ url: supabaseUrl, anonKey: supabaseAnonKey });
  }

  getClient(): SupabaseClient {
    return this.client;
  }

  async validateConnection(): Promise<boolean> {
    return validateConnection(this.client);
  }
}
